export default {
  GET_REGIONS: (state) => state.regions,
  GET_PROVINCES: (state) => state.provinces,
  GET_CITIES: (state) => state.cities,
  GET_BARANGAYS: (state) => state.barangays,
};
